// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1CRAC","productName":"Table_productName__3yUn5"};